import { useEffect } from 'react';

import { gql } from '@apollo/client';

import { useShortUrlCreateMutation } from 'src/generated/mloop-graphql';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const ShortUrlCreateMutation = gql`
  mutation ShortUrlCreate($input: ShortUrlCreateInput!) {
    shortUrlCreate(input: $input) {
      shortUrl
    }
  }
`;

const useShortUrlCreate = (longUrl: string) => {
  const [createShortUrl, result] = useShortUrlCreateMutation();

  // eslint-disable-next-line modernloop/no-use-effect.cjs -- Effect intentionally performs a side effect after render; revisit before adding logic.
  useEffect(() => {
    if (!longUrl) {
      return;
    }
    createShortUrl({ variables: { input: { longUrl } } });
  }, [createShortUrl, longUrl]);

  return result;
};

export default useShortUrlCreate;
